var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table summary-table"},[(_vm.$slots.thead)?_c('thead',[_vm._t("thead")],2):_vm._e(),_vm._v(" "),_c('tbody',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }